import axios from "axios";
import { environment } from "../../../environments/environment";

export function getPartRequestSupplyChainList(
  page = 0,
  pageSize = 10,
  search,
  sortingOrder
) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push({
    columnName: "company_id",
    value: companyIds,
  });
  return axios.post(
    `${environment.getPartRequestSupplyChainList}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}
export function getPartRequestSupplyChainListTranser(
  page = 0,
  pageSize = 10,
  search,
  sortingOrder,
  partId,
  orgLocationId,
  destLocationId
) {
  let filterArray = [];
  filterArray.push({
    columnName: "company_id",
    value: [parseInt(localStorage.getItem("u_company_id"))],
  });
  return axios.post(
    `${environment.getPartRequestSupplyChainListTransfer}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&partId=${partId}&orgLocationId=${orgLocationId}&destLocationId=${destLocationId}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export const createTransferPartRequest = (body) => {
  return axios.post(environment.createMultipleTransferPR, body);
};

export function companyStockByPart(
  page = 0,
  pageSize = 10,
  search,
  sortingOrder,
  locationId,
  partId
) {
  let filterArray = [];
  filterArray.push({
    columnName: "company_id",
    value: [parseInt(localStorage.getItem("u_company_id"))],
  });
  return axios.post(
    `${environment.companyStockByPart}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}&locationId=${locationId}&partId=${partId}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}


export function getVendorInfo(vendorId) {
  return axios.get(environment.getVendorInfo + "?vendorId=" + vendorId, {
    hideLoader: true,
  });
}

export function getTermsAndCondition(companyId) {
  return axios.get(environment.getTermsAndCondition + "?companyId=" + companyId, {
    hideLoader: true,
  });
}


export const createNewOrder = (body) => {
  return axios.post(environment.createNewOrder, body);
};
export const createNewMultipleOrder = (body) => {
  return axios.post(environment.createNewMultipleOrder, body);
};
